import { z } from "zod";

export const getTourWavesQuerySchema = z.object({
	weekday: z.coerce.number().min(0).max(6).optional(),
});

export type GetTourWavesQuery = z.infer<typeof getTourWavesQuerySchema>;
